// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-flammability-properties.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-flammability-properties/fuel-flammability-properties.js';

mount([g0]);
